module.exports = __webpack_public_path__ + "img/GE.78c674e5.svg";